import { Box, Grid, Typography } from "@mui/material"
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { useMemo } from "react";
import { Pie } from 'react-chartjs-2';
import { useAppSelector } from "../../../../../../../application/states/hooks";
ChartJS.register(ArcElement, ChartTooltip, Legend);

export const BusinessCharts = () => {
  const projectReport = useAppSelector((state) => state.project.projectReport)
  const businessPhones = useMemo(() => {
    return {

      labels: ['Empresas sem telefone', 'Empresas com telefone'],
      datasets: [
        {
          label: 'empresas',
          data: [
            projectReport?.generalData.business.phone.withoutPhone,
            projectReport?.generalData.business.phone.withPhone
          ],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)'
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          borderWidth: 1,
        },
      ],
    }
  }, [projectReport?.generalData.business.phone])
  const businessEmails = useMemo(() => {
    return {

      labels: ['Empresas sem e-mail', 'Empresas com e-mail'],
      datasets: [
        {
          label: 'empresas',
          data: [
            projectReport?.generalData.business.email.withoutEmail,
            projectReport?.generalData.business.email.withEmail
          ],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)'
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          borderWidth: 1,
        },
      ],
    }
  }, [projectReport?.generalData.business.email])

  const businessAddress = useMemo(() => {
    return {
      labels: ['Empresa sem endereço', 'Empresas com endereço'],
      datasets: [
        {
          label: 'empresas',
          data: [
            projectReport?.generalData.business.address.withoutAddress,
            projectReport?.generalData.business.address.withAddress
          ],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)'
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          borderWidth: 1,
        },
      ],
    }
  }, [projectReport?.generalData.business.address])
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography align="center" fontWeight="bold" variant="h4" color="primary">
            Informações empresas
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item>
                <Pie color="white" data={businessPhones} />
              </Grid>
            </Grid>
            <Grid style={{
              marginTop: '15px'
            }} container justifyContent={"center"} spacing={2}>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(255, 99, 132, 1)',
                  }}>Sem telefone:</span>  {projectReport?.generalData.business.phone.withoutPhone.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(54, 162, 235, 1)'
                  }}>Com telefone:</span>  {projectReport?.generalData.business.phone.withPhone.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item>
                <Pie color="white" data={businessEmails} />
              </Grid>
            </Grid>
            <Grid style={{
              marginTop: '15px'
            }} container justifyContent={"center"} spacing={2}>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(255, 99, 132, 1)',
                  }}>Sem e-mail:</span>  {projectReport?.generalData.business.email.withoutEmail.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(54, 162, 235, 1)'
                  }}>Com e-mail:</span>  {projectReport?.generalData.business.email.withEmail.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item>
                <Pie color="white" data={businessAddress} />
              </Grid>
            </Grid>
            <Grid style={{
              marginTop: '15px'
            }} container justifyContent={"center"} spacing={2}>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(255, 99, 132, 1)',
                  }}>Sem endereço:</span>  {projectReport?.generalData.business.address.withoutAddress.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(54, 162, 235, 1)'
                  }}>Com endereço:</span>  {projectReport?.generalData.business.address.withAddress.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}